/* =====================================================================
   VYRON PREMIUM — animaciones, galería, variantes y carrito lateral
   JavaScript sin librerías. Respeta "reducir movimiento".
   ===================================================================== */
(function () {
  if (window.__vyIniciado) return;
  window.__vyIniciado = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var reduce = mq.matches;
  var punteroFino = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- 1. Revelado al desplazarse ---------- */
  var observador = null;
  function initReveal(root) {
    var els = $all('.vy-reveal:not(.vy-visible)', root);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('vy-visible'); }); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('vy-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- 2. Título del hero palabra por palabra ---------- */
  function partirEnPalabras(nodo, contador) {
    var hijos = Array.prototype.slice.call(nodo.childNodes);
    hijos.forEach(function (h) {
      if (h.nodeType === 3) {
        var partes = h.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        partes.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var envoltura = document.createElement('span');
          envoltura.className = 'vy-palabra';
          var interior = document.createElement('span');
          interior.textContent = p;
          interior.style.setProperty('--i', contador.n++);
          envoltura.appendChild(interior);
          frag.appendChild(envoltura);
        });
        nodo.replaceChild(frag, h);
      } else if (h.nodeType === 1 && !h.classList.contains('vy-palabra')) {
        partirEnPalabras(h, contador);
      }
    });
  }
  function initHero(root) {
    $all('[data-vy-split]', root).forEach(function (h) {
      if (h.__vySplit) return; h.__vySplit = true;
      var seccion = h.closest('[data-vy-hero]') || h.parentNode;
      if (reduce) { seccion.classList.add('vy-titulo-listo'); return; }
      partirEnPalabras(h, { n: 0 });
      requestAnimationFrame(function () { requestAnimationFrame(function () { seccion.classList.add('vy-titulo-listo'); }); });
    });
  }

  /* ---------- 3. Profundidad: parallax suave + inclinación con el cursor ---------- */
  var capas = [];
  var rafPar = false;
  function moverCapas() {
    rafPar = false;
    var vh = window.innerHeight;
    capas.forEach(function (c) {
      var r = c.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var centro = r.top + r.height / 2 - vh / 2;
      c.y = -centro * c.vel;
      c.el.style.transform = 'translate3d(0,' + c.y.toFixed(1) + 'px,0) ' + (c.tilt || '');
    });
  }
  function initParallax(root) {
    if (reduce || window.innerWidth < 990) return;
    $all('[data-vy-par]', root).forEach(function (el) {
      if (el.__vyPar) return; el.__vyPar = true;
      capas.push({ el: el, vel: parseFloat(el.getAttribute('data-vy-par')) || 0.05, y: 0, tilt: '' });
    });
    if (!window.__vyParScroll) {
      window.__vyParScroll = true;
      window.addEventListener('scroll', function () { if (!rafPar) { rafPar = true; requestAnimationFrame(moverCapas); } }, { passive: true });
    }
    moverCapas();
    if (!punteroFino) return;
    $all('[data-vy-parallax]', root).forEach(function (zona) {
      if (zona.__vyTilt) return; zona.__vyTilt = true;
      zona.addEventListener('pointermove', function (e) {
        var r = zona.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        capas.forEach(function (c, i) {
          if (!zona.contains(c.el)) return;
          var f = 2 + i * 1.2;
          c.tilt = 'rotateY(' + (x * f).toFixed(2) + 'deg) rotateX(' + (-y * f).toFixed(2) + 'deg)';
        });
        if (!rafPar) { rafPar = true; requestAnimationFrame(moverCapas); }
      });
      zona.addEventListener('pointerleave', function () { capas.forEach(function (c) { c.tilt = ''; }); moverCapas(); });
      zona.style.perspective = '1200px';
    });
  }

  /* ---------- 4. Botón magnético (solo con mouse) ---------- */
  function initMagnetico(root) {
    if (reduce || !punteroFino) return;
    $all('[data-vy-magnetico]', root).forEach(function (b) {
      if (b.__vyMag) return; b.__vyMag = true;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.3;
        b.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + (y - 2).toFixed(1) + 'px,0)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- 5. Carruseles de productos ---------- */
  function initCarruseles(root) {
    $all('[data-vy-carrusel]', root).forEach(function (sec) {
      if (sec.__vyCar) return; sec.__vyCar = true;
      var pista = sec.querySelector('[data-vy-pista]');
      if (!pista) return;
      var prev = sec.querySelector('[data-vy-prev]'), next = sec.querySelector('[data-vy-next]'), prog = sec.querySelector('[data-vy-prog]');
      function paso() { var item = pista.firstElementChild; return item ? item.getBoundingClientRect().width + 18 : pista.clientWidth * 0.8; }
      function actualizar() {
        var max = pista.scrollWidth - pista.clientWidth;
        if (prev) prev.disabled = pista.scrollLeft <= 2;
        if (next) next.disabled = pista.scrollLeft >= max - 2;
        if (prog) {
          var visible = pista.clientWidth / pista.scrollWidth;
          prog.style.setProperty('--vy-prog-ancho', (visible * 100) + '%');
          prog.style.setProperty('--vy-prog-x', (max > 0 ? (pista.scrollLeft / max) * ((1 / visible) - 1) * 100 : 0) + '%');
        }
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      pista.addEventListener('scroll', function () { requestAnimationFrame(actualizar); }, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();
    });
  }

  /* ---------- 6. Galería de producto: miniaturas, flechas, deslizar, zoom ---------- */
  function initGaleria(root) {
    $all('[data-vy-galeria]', root).forEach(function (gal) {
      if (gal.__vyGal) return; gal.__vyGal = true;
      var principal = gal.querySelector('[data-vy-principal]');
      var marco = gal.querySelector('.vy-galeria__principal');
      var minis = $all('[data-vy-mini]', gal);
      var puntos = $all('.vy-galeria__puntos span', gal);
      if (!principal) return;
      var actual = Math.max(0, minis.findIndex ? minis.findIndex(function (m) { return m.classList.contains('is-activa'); }) : 0);

      function mostrar(i) {
        if (!minis.length) return;
        i = (i + minis.length) % minis.length;
        if (i === actual && principal.getAttribute('src') === minis[i].getAttribute('data-src')) return;
        actual = i;
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === i); });
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        marco.classList.remove('is-zoom');
        var src = minis[i].getAttribute('data-src');
        if (reduce) { principal.src = src; principal.removeAttribute('srcset'); return; }
        principal.classList.add('is-saliendo');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          principal.src = src; principal.removeAttribute('srcset');
          requestAnimationFrame(function () { principal.classList.remove('is-saliendo'); });
        };
        pre.src = src;
      }
      gal.__vyMostrarMedia = function (mediaId) {
        var k = minis.findIndex(function (m) { return m.getAttribute('data-media-id') === String(mediaId); });
        if (k > -1) mostrar(k);
      };
      minis.forEach(function (m, k) { m.addEventListener('click', function () { mostrar(k); }); });
      var bp = gal.querySelector('[data-vy-gal-prev]'), bn = gal.querySelector('[data-vy-gal-next]');
      if (bp) bp.addEventListener('click', function (e) { e.stopPropagation(); mostrar(actual - 1); });
      if (bn) bn.addEventListener('click', function (e) { e.stopPropagation(); mostrar(actual + 1); });

      // deslizar con el dedo
      var x0 = null, y0 = null;
      marco.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      marco.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) mostrar(actual + (dx < 0 ? 1 : -1));
        x0 = y0 = null;
      });
      // zoom con el mouse
      if (punteroFino) {
        marco.addEventListener('click', function (e) {
          if (e.target.closest('button')) return;
          marco.classList.toggle('is-zoom');
        });
        marco.addEventListener('pointermove', function (e) {
          if (!marco.classList.contains('is-zoom')) return;
          var r = marco.getBoundingClientRect();
          principal.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        marco.addEventListener('pointerleave', function () { marco.classList.remove('is-zoom'); });
      }
      document.addEventListener('keydown', function (e) {
        if (!gal.matches(':hover')) return;
        if (e.key === 'ArrowLeft') mostrar(actual - 1);
        if (e.key === 'ArrowRight') mostrar(actual + 1);
      });
    });
  }

  /* ---------- 7. Variantes y cantidad ---------- */
  function initProducto(root) {
    $all('[data-vy-producto]', root).forEach(function (box) {
      if (box.__vyProd) return; box.__vyProd = true;
      var variantes = [];
      try { variantes = JSON.parse((box.querySelector('[data-vy-variantes]') || {}).textContent || '[]'); } catch (e) {}
      var sid = box.getAttribute('data-vy-producto');
      var inputsId = $all('input[name="id"]', box);
      var precioEls = $all('[data-vy-precio-' + sid + ']');
      var botones = $all('[data-vy-boton]', box);
      var disp = box.querySelector('[data-vy-disponible]');
      var gal = box.querySelector('[data-vy-galeria]');

      function seleccion() { return $all('[data-vy-opcion]', box).map(function (g) { var m = g.querySelector('input:checked'); return m ? m.value : null; }); }
      function actualizar() {
        var sel = seleccion();
        $all('[data-vy-opcion]', box).forEach(function (g, i) { var s = g.querySelector('[data-vy-op-valor]'); if (s) s.textContent = sel[i] || ''; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { botones.forEach(function (b) { b.disabled = true; }); return; }
        inputsId.forEach(function (i) { i.value = v.id; });
        precioEls.forEach(function (p) {
          p.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
          if (!reduce && p.animate) p.animate([{ opacity: .3, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.16,1,.3,1)' });
        });
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var l = b.querySelector('[data-vy-label]');
          if (l) l.textContent = v.available ? b.getAttribute('data-texto') : (box.getAttribute('data-agotado') || 'Agotado');
        });
        if (disp) { disp.textContent = v.available ? disp.getAttribute('data-si') : disp.getAttribute('data-no'); disp.classList.toggle('is-agotado', !v.available); }
        if (v.media && gal && gal.__vyMostrarMedia) gal.__vyMostrarMedia(v.media);
        if (window.history && history.replaceState && !document.documentElement.classList.contains('shopify-design-mode')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
        }
      }
      $all('[data-vy-opcion] input', box).forEach(function (i) { i.addEventListener('change', actualizar); });

      $all('[data-vy-cantidad]', box).forEach(function (c) {
        var input = c.querySelector('input');
        function sync() {
          var n = Math.max(1, parseInt(input.value, 10) || 1); input.value = n;
          $all('input[name="quantity"]', box).forEach(function (q) { q.value = n; });
          input.classList.remove('is-bump'); void input.offsetWidth; input.classList.add('is-bump');
        }
        $all('button', c).forEach(function (b) {
          b.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-paso'), 10); sync(); });
        });
        input.addEventListener('change', sync);
      });

      var barra = document.querySelector('[data-vy-barra="' + sid + '"]');
      var ancla = box.querySelector('[data-vy-ancla-compra]');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(ancla);
      }
    });
  }

  /* ---------- 8. Carrito lateral real (API de carrito de Shopify) ---------- */
  function rebotarIcono() {
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono || reduce) return;
    icono.classList.remove('is-bump'); void icono.offsetWidth; icono.classList.add('is-bump');
  }
  function initCarrito() {
    if (window.__vyCarrito) return; window.__vyCarrito = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('form[data-vy-ajax]')) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // sin carrito lateral: envío normal
      e.preventDefault();
      var boton = form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-vy-error]');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (boton) { boton.classList.add('is-cargando'); boton.setAttribute('aria-busy', 'true'); }
      var datos = new FormData(form);
      datos.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      datos.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', body: datos, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            var msg = res.description || res.message || 'No pudimos agregar el producto. Inténtalo de nuevo.';
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
            return;
          }
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          rebotarIcono();
          if (boton) {
            boton.classList.add('is-ok');
            setTimeout(function () { boton.classList.remove('is-ok'); }, 1400);
          }
        })
        .catch(function () { form.removeAttribute('data-vy-ajax'); form.submit(); })
        .finally(function () { if (boton) { boton.classList.remove('is-cargando'); boton.removeAttribute('aria-busy'); } });
    });
  }

  /* ---------- 9. Encabezado con sombra al bajar ---------- */
  function initEncabezado() {
    if (window.__vyHead) return; window.__vyHead = true;
    var pend = false;
    function act() { pend = false; document.documentElement.classList.toggle('vy-scrolleado', window.scrollY > 8); }
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(act); } }, { passive: true });
    act();
  }

  /* ---------- 10. Vitrina con pestañas ---------- */
  function initVitrina(root) {
    $all('[data-vy-vitrina]', root).forEach(function (sec) {
      if (sec.__vyTabs) return; sec.__vyTabs = true;
      var lista = sec.querySelector('.vy-tabs'), ind = sec.querySelector('.vy-tabs__indicador');
      var tabs = $all('[role="tab"]', sec);
      function mover(tab) {
        if (!ind || !tab) return;
        lista.style.setProperty('--x', tab.offsetLeft + 'px');
        lista.style.setProperty('--w', tab.offsetWidth + 'px');
      }
      function activar(tab, foco) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-activa', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          panel.classList.toggle('is-activa', on);
          if (on && !reduce) { panel.classList.remove('is-entrando'); void panel.offsetWidth; panel.classList.add('is-entrando'); }
        });
        mover(tab);
        if (foco) tab.focus();
        if (tab.scrollIntoView && lista.scrollWidth > lista.clientWidth) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
      function precargar(t) {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel && !panel.__vyPre) { panel.__vyPre = true; $all('img[loading="lazy"]', panel).forEach(function (im) { im.loading = 'eager'; }); }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('pointerenter', function () { precargar(t); });
        t.addEventListener('focus', function () { precargar(t); });
        t.addEventListener('click', function () { precargar(t); activar(t); });
        t.addEventListener('keydown', function (e) {
          var k = null;
          if (e.key === 'ArrowRight') k = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') k = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') k = tabs[0];
          if (e.key === 'End') k = tabs[tabs.length - 1];
          if (k) { e.preventDefault(); activar(k, true); }
        });
      });
      var activa = sec.querySelector('.vy-tab.is-activa') || tabs[0];
      requestAnimationFrame(function () { mover(activa); lista.classList.add('is-listo'); });
      window.addEventListener('resize', function () { mover(sec.querySelector('.vy-tab.is-activa')); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { mover(sec.querySelector('.vy-tab.is-activa')); });
    });
  }
  /* ---------- 11. Botón Volver: vuelve a la página anterior de la tienda si existe ---------- */
  function initVolver(root) {
    $all('[data-vy-volver]', root).forEach(function (a) {
      if (a.__vyVolver) return; a.__vyVolver = true;
      a.addEventListener('click', function (e) {
        var ref = document.referrer;
        if (ref && ref.indexOf(window.location.origin) === 0 && ref !== window.location.href && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    });
  }
  /* ---------- 12. Portada con diapositivas (sin avance automático salvo que se active) ---------- */
  function initPortada(root) {
    $all('[data-vy-portada]', root).forEach(function (sec) {
      if (sec.__vyPortada) return; sec.__vyPortada = true;
      var slides = $all('.vy-portada__slide', sec), puntos = $all('[data-vy-p-ir]', sec);
      if (slides.length < 2) return;
      var actual = 0, timer = null, segundos = parseInt(sec.getAttribute('data-auto'), 10);
      function ir(n) {
        actual = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === actual;
          s.classList.toggle('is-activa', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        });
        puntos.forEach(function (p, i) { p.classList.toggle('is-activa', i === actual); p.setAttribute('aria-selected', i === actual ? 'true' : 'false'); });
      }
      function reiniciar() {
        if (!segundos) return; // pasa sola siempre (pedido del dueño), aunque el dispositivo pida menos movimiento
        clearInterval(timer);
        timer = setInterval(function () { ir(actual + 1); }, segundos * 1000);
      }
      var prev = sec.querySelector('[data-vy-p-prev]'), next = sec.querySelector('[data-vy-p-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); reiniciar(); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); reiniciar(); });
      puntos.forEach(function (p) { p.addEventListener('click', function () { ir(parseInt(p.getAttribute('data-vy-p-ir'), 10)); reiniciar(); }); });
      sec.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { ir(actual + 1); reiniciar(); }
        if (e.key === 'ArrowLeft') { ir(actual - 1); reiniciar(); }
      });
      var x0 = null, y0 = null;
      sec.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      sec.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { ir(actual + (dx < 0 ? 1 : -1)); reiniciar(); }
        x0 = null;
      }, { passive: true });
      if (segundos) {
        sec.addEventListener('mouseenter', function () { clearInterval(timer); });
        sec.addEventListener('mouseleave', reiniciar);
        sec.addEventListener('focusin', function () { clearInterval(timer); });
        reiniciar();
      }
    });
  }

  /* ---------- 13. Menú desplegable: se abre al pasar el mouse (computadora) ---------- */
  function initMenuHover() {
    if (window.__vyMenuHover || !punteroFino) return; window.__vyMenuHover = true;
    $all('.header__inline-menu details').forEach(function (d) {
      var t = null;
      d.addEventListener('mouseenter', function () { clearTimeout(t); d.setAttribute('open', ''); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true'); });
      d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }, 160); });
    });
  }

  /* ---------- 14. Barra inferior del celular ---------- */
  function initNavMovil() {
    if (window.__vyNavm) return; window.__vyNavm = true;
    var nav = document.querySelector('.vy-navm');
    if (!nav) return;
    var menuBtn = nav.querySelector('[data-vy-abrir-menu]');
    if (menuBtn) menuBtn.addEventListener('click', function () {
      var s = document.querySelector('header-drawer summary');
      if (s) { window.scrollTo({ top: 0, behavior: 'auto' }); s.click(); }
      else window.location.href = '/collections/all';
    });
    var buscar = nav.querySelector('[data-vy-buscar]');
    if (buscar) buscar.addEventListener('click', function () {
      var input = document.getElementById('VyBuscador');
      if (!input) { window.location.href = '/search'; return; }
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { input.focus(); }, reduce ? 0 : 250);
    });
    var carrito = nav.querySelector('[data-vy-abrir-carrito]');
    if (carrito) carrito.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(carrito);
      }
    });
    var cuenta = nav.querySelector('[data-vy-cuenta]'), burbuja = document.getElementById('cart-icon-bubble');
    function sincronizar() {
      if (!cuenta || !burbuja) return;
      var n = burbuja.querySelector('.cart-count-bubble span[aria-hidden]');
      var valor = n ? parseInt(n.textContent, 10) || 0 : 0;
      cuenta.textContent = valor; cuenta.hidden = valor === 0;
    }
    if (burbuja && 'MutationObserver' in window) new MutationObserver(sincronizar).observe(burbuja, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 15. Filtros de colección ---------- */
  function initFiltros(root) {
    $all('[data-vy-filtros]', root).forEach(function (f) {
      if (f.__vyF) return; f.__vyF = true;
      $all('[data-vy-auto]', f).forEach(function (c) { c.addEventListener('change', function () { f.requestSubmit ? f.requestSubmit() : f.submit(); }); });
      f.addEventListener('submit', function () { $all('input', f).forEach(function (i) { if (i.type === 'number' && !i.value) i.disabled = true; }); });
    });
    $all('[data-vy-filtros-btn]', root).forEach(function (b) {
      if (b.__vyFB) return; b.__vyFB = true;
      b.addEventListener('click', function () {
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (!panel) return;
        var abierto = panel.classList.toggle('is-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initTodo(root) {
    initPortada(root);
    initMenuHover();
    initNavMovil();
    initFiltros(root);
    initHero(root);
    initReveal(root);
    initParallax(root);
    initMagnetico(root);
    initCarruseles(root);
    initVitrina(root);
    initGaleria(root);
    initProducto(root);
    initVolver(root);
    initCarrito();
    initEncabezado();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
